import OnboardingFlow from "../shared/onboarding-flow";

import { getInitialStepId, useGetCIMOnboardingPhases, useOnPhaseFinished } from "./phases/steps-logic";
import { CIM_ONBOARDING_STEPS } from "./phases/steps-ui";
import { useFeatureFlag } from "frontend/hooks/use-feature-flag/use-feature-flag";

export default function CIMOnboardingFlow() {
  const isCIMOnboardingEnabled = useFeatureFlag("cim-onboarding");
  const onPhaseFinished = useOnPhaseFinished();
  const phases = useGetCIMOnboardingPhases();

  if (!isCIMOnboardingEnabled) {
    return null;
  }

  return (
    <OnboardingFlow
      phases={phases}
      steps={CIM_ONBOARDING_STEPS}
      getInitialStepId={getInitialStepId}
      onPhaseFinished={onPhaseFinished}
    />
  );
}
